// eslint-disable-next-line no-shadow
export enum ControlNetModelsType {
	SD15 = 'SD 1.5',
	SDXL = 'SDXL',
	Flux = 'flux',
}
